/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  default-case,
  guard-for-in,
  max-len,
  new-cap,
  no-nested-ternary,
  no-param-reassign,
  no-proto,
  no-restricted-syntax,
  no-use-before-define,
  prefer-rest-params
*/

/**
 * creates a new factory for creating items
 */

export default function (contextClass) {
  if (!contextClass) contextClass = Object;

  // creates a new object from a class
  function create(arg1, arg2, arg3, arg4) {

    // dirty but fast
    switch (arguments.length) {
      case 1: return new this(arg1);
      case 2: return new this(arg1, arg2);
      case 3: return new this(arg1, arg2, arg3);
      case 4: return new this(arg1, arg2, arg3, arg4);
    }

    // handle edge here.
    // TODO - make this faster.
    return createFromContext.apply(this, arguments);
  }

  // creates an object from *any* native class
  function createFromContext() {
    const context = new contextClass();
    context.__proto__ = this.prototype;
    this.apply(context, arguments);
    return context;
  }

  function createAndCopyToContext() {
    const context = new contextClass();
    for (const k in this.prototype) context[k] = this.prototype[k];
    this.apply(context, arguments);
    return context;
  }

  // context class Object? Use the faster method instead.
  return contextClass === Object ? create : contextClass === Array ? createAndCopyToContext : createFromContext;
}
